import React, { useEffect, useState } from "react";
import { ContentWrapper } from "../../utils/components";
import '../../styles/News.css';

const News = () => {
    const [newsItems, setNewsItems] = useState([]);

    const fetchNewsItems = async () => {
        try {
            const response = await fetch('https://www.autoservicethomas.be/api/news/visible');
            const data = await response.json();
            const sortedData = data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setNewsItems(sortedData);
        } catch (error) {
            console.error('Fout bij ophalen meldingen:', error);
        }
    };

    useEffect(() => {
        fetchNewsItems();
    }, []);

    const formatDateTime = (dateString) => {
        return `${new Date(dateString).toLocaleString('nl-BE', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        })} uur`;
    };

    return (
        <div>
            {newsItems?.length > 0 && (
                <section className="section news-section">
                    <ContentWrapper>
                        <h2 className="title news-title">Nieuws</h2>
                        <div className="news-grid">
                            {newsItems?.map((post) => (
                                <div key={post?._id} className="news-card">
                                    <img
                                        src={`https://autoservicethomas.be/uploads/news/${post?.photo}`}
                                        alt={post?.title || "Nieuws afbeelding"}
                                        className="news-image"
                                    />
                                    <div className="news-content">
                                        <h3 className="news-title-card">{post?.title}</h3>
                                        <hr className="about-break news" />
                                        <div className="news-links">
                                            {
                                                post?.localUrl ? <a
                                                    href={post?.localUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    title="Voertuig te koop link"
                                                    className="social-link more"
                                                >
                                                    Meer info
                                                </a> : <>{post?.urlFacebook && (
                                                    <a
                                                        href={post?.urlFacebook}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        title="Facebook link"
                                                        className="social-link facebook"
                                                    >
                                                        Facebook
                                                    </a>
                                                )}
                                                    {post?.urlInstagram && (
                                                        <a
                                                            href={post?.urlInstagram}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            title="Instagram link"
                                                            className="social-link instagram"
                                                        >
                                                            Instagram
                                                        </a>
                                                    )}</>
                                            }
                                        </div>

                                        <p className="news-date">{formatDateTime(post?.createdAt)}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </ContentWrapper>
                </section>
            )}
        </div>
    );
}

export default News;